import { Injectable } from '@angular/core';

import 'rxjs/Rx';

import { QueryService } from '../../shared/query.service';
import { Product } from '../../_models/product';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class OverviewService {
  public importedProducts: Product[] = [];
  public loadingImportedProducts = false;
  public processedProducts: Product[] = [];
  public loadingProcessedProducts = false;

  constructor(private queryService: QueryService) {
    this.refreshImportedAndProcessedProducts();
  }

  refreshImportedAndProcessedProducts(): void {
    this.loadingImportedProducts = true;
    this.loadingProcessedProducts = true;
    this.getNewProducts();
    this.getNewProducts(true);
  }

  getNewProducts(processed: boolean = false): void {
    let url = '/products/?status=imported';
    if (processed) {
      url = '/products/?status=processed';
    }
    this.queryService.getQuery(url).subscribe(result => {
      if (processed) {
        this.processedProducts = result;
        this.loadingProcessedProducts = false;
      } else {
        this.importedProducts = result;
        this.loadingImportedProducts = false;
      }
      }
    );
  }

  getSimilarProducts(product: Product, status: string): Observable<Product[]> {
    return this.queryService.getQuery('/products/' + product.id + '/similar/');
  }
}



// WEBPACK FOOTER //
// /app/src/app/hq/overview/overview.service.ts